<template>
	<page-content-layout class="leads" title="Leads">
		<button-group-view slot="tools" :actions="[
			{
				label: 'Ny',
				value: 'new'
			},
			{
				label: 'Afventer',
				value: 'pending'
			},
			{
				label: 'Følg op',
				value: 'followup'
			}
		]" v-model="filter" />
		<button-view slot="tools" label="Opret" @click="open(null)" />
		<new-table-view @itemClick="itemClick" :columns="[
			{
				label: 'Status',
				name: ['status'],
				translation: _status,
				template: {
					name: 'status',
					params: {
						color: {
							name: ['status'],
							translation: _statusColors
						},
						description: {
							name: ['status'],
							translation: _statusDesc
						}
					}
				}
			},
			{
				label: 'Modtaget',
				name: 'created',
				filter: 'timestamp',
				weight: 2
			},
			{
				label: 'Nr',
				name: 'num',
				filter: 'integer'
			},
			{
				label: 'Type',
				name: ['details', 'type'],
				translation: {
					private: 	'Privat',
					business: 	'Erhverv'
				}
			},
			/*{
				label: 'Oprettet',
				name: 'created',
				filter: 'timestamp'
			},*/
			{
				label: 'Kvm',
				name: ['details', 'area']
			},
			{
				label: 'Fra',
				name: ['details', 'address', 'city']
			},
			{
				label: 'Til',
				name: ['details', 'dest', 'city']
			},
			{
				label: 'Navn',
				name: 'name'
			},
			{
				label: 'Telefon',
				name: 'phone',
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Kunde',
				name: ['_embedded', 'contact', 'name'],
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Ansvarlig',
				name: ['_embedded', 'employee', 'name'],
				//filter: 'float',
				//align: 'right'
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				}
			}			
		]" :items="_items" @context="itemContext" />
	</page-content-layout>
</template>

<script>
	import LeadModel from '../model/Lead'
	import LeadWindow from '../windows/LeadWindow'
	import NewTableView from '../views/NewTableView'
	import merge from '../functions/merge'
	import ContextPopupView from '../views/ContextPopupView'

	import ContactModel from '../model/Contact'

	import QuoteModel from '../model/Quote'
	import QuoteWindow from '../windows/QuoteWindow'

	import MoveTaskModel from '../model/MoveTask'
	import OrderModel from '../model/Order'
	import OrderWindow from '../windows/OrderWindow'

	import SurveyTaskModel from '../model/SurveyTask'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'

	import FollowupWindow from '../windows/FollowupWindow'

	import { bus } from '../../bus';

    export default {
		data() {
			return {
				items: [],
				sources: [],
				motivations: [],
				colors: [],
				status: [],
				filter: 'new'
			};
		},
		computed: {
			_items() {
				var r = [];

				if (this.items) {
					for (var i = 0; i < this.items.length; ++i) {
						if (this.filter == this.items[i].status) {
							r.push(this.items[i]);
						}
					}
				}

				return r;
			},
			_sources() {
				var r = [];

				for (var i = 0; i < this.sources.length; ++i) {
					r[this.sources[i].name] = this.sources[i].label;
				}

				return r;
			},
			_motivations() {
				var r = [];

				for (var i = 0; i < this.motivations.length; ++i) {
					r[this.motivations[i].name] = this.motivations[i].label;
				}

				return r;
			},
			_status() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].label;
				}

				return r;
			},
			_statusColors() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this._colors[this.status[i].color];
				}

				

				return r;
			},
			_statusDesc() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].desc;
				}

				return r;
			},
			_colors() {
				var r = [];

				for (var i = 0; i < this.colors.length; ++i) {
					r[this.colors[i].name] = this.colors[i].color;
				}

				return r;
			}
		},
		components: {
			'NewTableView': NewTableView
		},
		methods: {
			TopUpdateMixin_update() {
				
			},
			async itemClick(item) {
				this.open(item.id);
			},
			async autoCustomer(ent, item) {
				var contact = null;

				

				if (item.contact_id === null) {
					if (confirm('Vil du oprette en kontakt til formålet?')) {
						var c = ContactModel.entity();
						c.name 		= item.name;
						c.email 	= item.email;
						c.phone 	= item.phone;
						c.address	= item.details.address.address;
						c.zip		= item.details.address.zip;
						c.city		= item.details.address.city;
						c.country	= item.details.address.country;
						c.roles		= {};

						if (item.details.type == 'private') {
							c.roles['private'] = { enabled: true };
						}

						if (item.details.type == 'business') {
							c.roles['business'] = { enabled: true };
						}

						contact = await ContactModel.save(this.axios, c);

						// Update lead
						var lead 				= await LeadModel.read(this.axios, item.id);
						lead.contact_id 		= contact.id;

						LeadModel.save(this.axios, lead);					
					}
				} else {
					contact = await ContactModel.read(this.axios, item.contact_id);
				}

				if (contact !== null) {
					ent.contact_id 			= contact.id;
					ent._embedded.contact	= contact;
				}

				return ent;
			},
			itemContext(item, event) {
				event.stopPropagation();

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: [
						{
							label: 'Følg op senere',
							action: () => {
								var self 	= this;
								var from 	= new Date();

								this.$store.state.windowStack.push(FollowupWindow, {
									date: 	from.format('Y-m-d'),
									time: 	from.format('H:i'),
									async submit(date, time) {
										self.axios
											.put(`/sales/leads/${item.id}/followup/`, {
												date,
												time
											})
											.then(function (r) {
												self.$store.state.windowStack.pop();
												self.update();
											});
									}
								});
							}
						},
						{
							label: 'Ingen kontakt',
							action: () => {
								const self = this;

								self.axios
									.put(`/sales/leads/${item.id}/no-contact/`)
									.then(function (r) {
										self.update();
									});
							}
						},
						{
							label: 'Ingen interesse',
							action: () => {
								const self = this;

								self.axios
									.put(`/sales/leads/${item.id}/no-interest/`)
									.then(function (r) {
										self.update();
									});
							}
						},
						null,
						{
							label: 'Opret besigtigelse',
							action: async function () {
								// Auto create customer?
								var ent 				= SurveyTaskModel.entity();
								ent.employee_id 		= self.$store.state.employee.id;
								ent.department_id 		= self.$store.state.employee.department_id;
								ent._embedded.employee	= self.$store.state.employee;

								ent.name				= item.name;
								ent.phone				= item.phone;
								ent.email				= item.email;

								ent.details.area		= item.details.area;
								ent.details.date		= item.details.date;
								ent.remarks				= item.comments;

								ent.details.address		= item.details.address;
								ent.details.dest		= item.details.dest;

								ent.contact_id			= item.contact_id;
								ent._embedded.contact	= item._embedded.contact;

								ent.lead_id 			= item.id; 


								

								ent = await self.autoCustomer(ent, item);

								self.$store.state.windowStack.push(SurveyTaskWindow, {
									value: ent,
									async submit(entity) {
										if (await SurveyTaskModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											//self.update();
											bus.$emit('update');
										}
									}
								});
							}
						},
						{
							label: 'Opret tilbud',
							action: async function () {
								var ent;
								ent 					= QuoteModel.entity();
								ent.employee_id 		= self.$store.state.employee.id;
								ent.department_id 		= self.$store.state.employee.department_id;
								ent._embedded.employee	= self.$store.state.employee;

								ent.customer.name		= item.name;
								ent.customer.phone		= item.phone;
								ent.customer.email		= item.email;

								ent.contact_id			= item.contact_id;
								ent._embedded.contact	= item._embedded.contact;

								ent.lead_id 			= item.id; 

								ent.remarks				= item.comments;

								ent = await self.autoCustomer(ent, item);

								// Add moving task
								var task 				= MoveTaskModel.entity();
								task.employee_id 		= self.$store.state.employee.id;
								task.department_id 		= self.$store.state.employee.department_id;
								task._embedded.employee	= self.$store.state.employee;

								task.name				= item.name;
								task.phone				= item.phone;
								task.email				= item.email;

								task.contact_id			= ent.contact_id;
								task._embedded.contact	= ent._embedded.contact;

								task.details.route		= [
									{
										address:		item.details.address.address,
										zip:			item.details.address.zip,
										city:			item.details.address.city,
										country:		item.details.address.country,
										instructions:	{},
										elevator:		false,
										distance:		''
									},
									{
										address:		item.details.dest.address,
										zip:			item.details.dest.zip,
										city:			item.details.dest.city,
										country:		item.details.dest.country,
										instructions:	{},
										elevator:		false,
										distance:		''
									}
								];

								task.details.area		= item.details.area;

								ent._embedded.tasks		= [task];


								

								self.$store.state.windowStack.push(QuoteWindow, {
									value: ent,
									lookup: true,
									async submit(entity) {
										if (await QuoteModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											//self.update();
											bus.$emit('update');
										}
									}
								});
							}
						},
						{
							label: 'Opret ordre',
							action: async function () {
								var ent;
								ent 					= OrderModel.entity();
								ent.employee_id 		= self.$store.state.employee.id;
								ent.department_id 		= self.$store.state.employee.department_id;
								ent._embedded.employee	= self.$store.state.employee;

								ent.customer.name		= item.name;
								ent.customer.phone		= item.phone;
								ent.customer.email		= item.email;

								ent.contact_id			= item.contact_id;
								ent._embedded.contact	= item._embedded.contact;

								ent.lead_id 			= item.id; 

								ent.remarks				= item.comments;

								ent = await self.autoCustomer(ent, item);

								// Add moving task
								var task 				= MoveTaskModel.entity();
								task.employee_id 		= self.$store.state.employee.id;
								task.department_id 		= self.$store.state.employee.department_id;
								task._embedded.employee	= self.$store.state.employee;

								task.name				= item.name;
								task.phone				= item.phone;
								task.email				= item.email;

								task.contact_id			= ent.contact_id;
								task._embedded.contact	= ent._embedded.contact;

								task.details.route		= [
									{
										address:		item.details.address.address,
										zip:			item.details.address.zip,
										city:			item.details.address.city,
										country:		item.details.address.country,
										instructions:	{},
										elevator:		false,
										distance:		''
									},
									{
										address:		item.details.dest.address,
										zip:			item.details.dest.zip,
										city:			item.details.dest.city,
										country:		item.details.dest.country,
										instructions:	{},
										elevator:		false,
										distance:		''
									}
								];

								task.details.area		= item.details.area;

								ent._embedded.tasks		= [task];


								self.$store.state.windowStack.push(OrderWindow, {
									value: ent,
									lookup: true,
									async submit(entity) {
										if (await OrderModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											self.update();
										}
									}
								});
							}
						},
						null,
						{
							label: 'Gensend bekraftelse til kunden',
							action: async function () {
								await self.axios.post('/sales/leads/' + item.id + '/resend/confirm/');
							}
						},
						{
							label: 'Gensend intern notifikation',
							action: async function () {
								await self.axios.post('/sales/leads/' + item.id + '/resend/forward/');
							}
						},
						null,
						{
							label: 'Slet',
							action: async function () {
								if (await LeadModel.delete(self.axios, item.id)) {
									//self.update();
									bus.$emit('update');
								}
							}
						}
					]
				});
			},
			async open(id) {
				var self = this;	
				var ent = id ? await LeadModel.read(self.axios, id) : LeadModel.entity();

				if (!id) {
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
				}

				

				this.$store.state.windowStack.push(LeadWindow, {
					value: ent, 
					submit: async function (entity) {
						

						var r = await LeadModel.save(self.axios, entity);

						
						

						if (r) {
							
							self.$store.state.windowStack.pop();
							//self.update();
							bus.$emit('update');
						}
					}
				});
			},
			update() {
				var self = this;

				self.items = null;

				this.axios
					.get('/sales/leads/')
					.then(function (r) {
						self.items = r.data._items;
					});
			}
		},
		mounted() {
			this.axios.put('/activity/leads/');

			this.update();
			//bus.$emit('update');

			var self = this;

			this.axios
				.get('/sales/leads/sources/')
				.then(function (r) {
					self.sources = r.data._items;
				});

			this.axios
				.get('/sales/leads/motivations/')
				.then(function (r) {
					self.motivations = r.data._items;
				});

			this.axios
				.get('/sales/leads/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/config/status/colors/')
				.then(function (r) {
					self.colors = r.data._items;
				});

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
	}
</script>

<style lang="scss">

</style>